import { TokenConfig, TokenDefinition } from '../types';

export type TokenMatch = {
  key: string;
  start: number;
  end: number;
  text: string;
};

const ensureGlobalFlag = (flags: string) =>
  flags.includes('g') ? flags : `${flags}g`;

const normalizeRegex = (match: RegExp) =>
  new RegExp(match.source, ensureGlobalFlag(match.flags));

export const countTokens = (value: string, match: RegExp): number => {
  const regex = normalizeRegex(match);
  return (value.match(regex) ?? []).length;
};

const linearizeMatch = (matches: TokenMatch[]) => {
  matches.sort((a, b) => a.start - b.start || b.end - a.end);

  const resolved: TokenMatch[] = [];
  let cursor = 0;
  matches.forEach(candidate => {
    if (candidate.start < cursor) return;
    resolved.push(candidate);
    cursor = candidate.end;
  });

  return resolved;
};

export const serializeTokenMatch = (
  definition: TokenDefinition,
  match: string,
): string => definition.serialize ?? match;

export const findTokenMatches = (
  value: string,
  config: TokenConfig,
): TokenMatch[] => {
  const matches: TokenMatch[] = [];

  Object.entries(config).forEach(([key, def]) => {
    const regex = normalizeRegex(def.match);
    for (const result of value.matchAll(regex)) {
      if (result[0].length === 0 || result.index === undefined) continue;
      matches.push({
        key,
        start: result.index,
        end: result.index + result[0].length,
        text: result[0],
      });
    }
  });

  return linearizeMatch(matches);
};
